<template>
	<v-card :id="'breqsent-[' + ('offer' in set ? 'P' : 'A') + set.request.booking_ref + ']'" :key="renderKey" class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-row no-gutters>
					<v-col cols="4" @click="practiceViewRequestSent">
						<v-skeleton-loader v-if="!avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>

						<v-list-item-avatar v-else-if="avatar && avatar != 'no-avatar'" width="60" height="60">
							<v-img :src="avatar"></v-img>
						</v-list-item-avatar>

						<v-list-item-avatar v-else width="60" height="60">
							<v-img :src="no_avatar"></v-img>
						</v-list-item-avatar>
					</v-col>
					<v-col cols="8">
						<div @click="practiceViewRequestSent">
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-title class="secondary--text subtitle-1 font-weight-bold">
										{{ ('offer' in set ? set.request : set.availability.professional).name }}
									</v-list-item-title>
									<v-list-item-subtitle class="subtitle-1 font-weight-bold">{{
										('offer' in set ? set.request : set.availability.professional).profession
									}}</v-list-item-subtitle>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-tooltip bottom>
										<template #activator="{ on, attrs }">
											<v-row no-gutters>
												<v-col cols="12">
													<v-list-item-title class="subtitle-2 font-weight-bold" v-bind="attrs" v-on="on"
														>{{ computedStartDateFormattedMomentjs }} - {{ computedEndDateFormattedMomentjs }}</v-list-item-title
													>
												</v-col>
											</v-row>
										</template>
										<span>
											<v-list-item-group>
												<v-list-item-subtitle v-for="date in set.request.booking_dates" :key="date" class="subtitle-2 font-weight-bold">{{
													date
												}}</v-list-item-subtitle>
											</v-list-item-group>
										</span>
									</v-tooltip>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-list-item-subtitle v-if="showTimes" class="pt-0 subtitle-2 black--text font-weight-bold"
										>{{ start_time }} - {{ end_time }}</v-list-item-subtitle
									>
									<v-list-item-subtitle v-else-if="!showTimes" class="pt-0 subtitle-2 black--text font-weight-bold">Times differ per day</v-list-item-subtitle>
								</v-col>
							</v-row>
							<v-row no-gutters class="pb-0 mb-0">
								<v-col cols="6">
									<v-list-item-subtitle class="pt-0 primary--text font-weight-bold"
										>#{{ 'booking_ref' in set.request ? set.request.booking_ref : set.request.uniqueAppReference }}</v-list-item-subtitle
									>
								</v-col>
							</v-row>
						</div>
						<v-row no-gutters>
							<v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="primary" bottom overlap bordered>
								<v-btn
									v-if="showMessageValid(set.request.booking_dates[this.set.request.booking_dates.length - 1])"
									class="white--text button-rounded mt-2"
									:height="25"
									color="accent"
									@click="openMessageDialog()"
									><span style="font-size: 12px">Message</span></v-btn
								>
							</v-badge>
						</v-row>
					</v-col>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="blue lighten-1" @click="practiceViewRequestSent">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import axios from 'axios';
import store from '@/store';

export default {
	name: 'PracticeBookingRequestSentCard',

	components: {},

	props: {
		set: { type: Object, required: true },
	},

	data: () => ({
		no_avatar: store.getters.noAvatar,
		avatar: false,
		renderKey: 0,
		showTimes: true,
		start_time: '',
		end_time: '',
		unreadMessageCount: 0,
	}),

	computed: {
		computedStartDateFormattedMomentjs() {
			return this.dateFormattedMomentjs(this.set.request.booking_dates[0]);
		},

		computedEndDateFormattedMomentjs() {
			return this.dateFormattedMomentjs(this.set.request.booking_dates[this.set.request.booking_dates.length - 1]);
		},

		company() {
			return store.getters.company;
		},
	},

	watch: {
		avatar() {
			this.renderKey += 1;
		},
	},

	async mounted() {
		await this.getUnreadMessageCount();
		this.$on('update-render', () => {
			this.renderKey += 1;
		});

		//fetch the locums avatar!
		const token = store.getters.jwtToken;
		const id = 'offer' in this.set ? this.set.request.id : this.set.availability.id;
		axios
			.get(store.getters.getDOCUMENTS + '/images/avatar/' + id, { headers: { Authorization: token } })
			.then(response => {
				this.avatar = 'data:image/png;base64,' + response.data.data;
				this.$emit('update-render');
			})
			.catch(() => {
				this.avatar = 'no-avatar';
			});

		this.getTimes();
	},

	methods: {
		...mapActions('message', ['GetConversationUnreadCount']),
		practiceViewRequestSent() {
			store.dispatch('setPracticeOfferSelected', this.set);

			let booking = {};
			let professionalId = null;
			const booking_dates = this.set.request.booking_dates;
			const booking_dates_times = this.set.request.booking_dates_times;

			if ('offer' in this.set) {
				const { start_time, end_time, lunch, notes, id, profession, rates, experience, request_dates, skills } = this.set.offer;

				booking = {
					start_time,
					end_time,
					lunch,
					notes,
					booking_dates,
					id,
					profession,
					rates,
					experience,
					request_dates,
					skills,
				};
				professionalId = this.set.request.id;
			} else if ('availability' in this.set) {
				const { date, id: availabilityId, professional } = this.set.availability;
				const { start_time, end_time, lunch, notes, id, rates, request_dates, skills } = this.set.request;
				booking = {
					date,
					start_time,
					end_time,
					lunch,
					notes,
					booking_dates,
					booking_dates_times,
					id,
					availabilityId,
					profession: professional.profession,
					rates,
					experience: professional.experience,
					request_dates,
					skills,
				};
				professionalId = professional.id;
			}

			store.dispatch('setPracticeViewingLocum', [{ id: professionalId, booking, source: 'viewBookingRequestSent' }]);
			bus.$emit('change-context', 'view-locum-details-card');
		},
		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},
		getTimes() {
			this.showTimes = true;
			this.start_time = this.set.offer.start_time;
			this.end_time = this.set.offer.end_time;
			for (let index = 0; index < this.set.offer.request_dates.length; index++) {
				if (
					moment(this.set.offer.request_dates[index].start_time).format('HH:mm') !== this.set.offer.start_time ||
					moment(this.set.offer.request_dates[index].end_time).format('HH:mm') !== this.set.offer.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},
		openMessageDialog() {
			const sentByID = this.company.id;
			let receiverDetails = {
				id: this.set.request.id,
				name: this.set.request.name,
			};
			bus.$emit('show-message-dialog', receiverDetails, sentByID);
			this.unreadMessageCount = 0;
		},

		showMessageValid(reqEndDate) {
			const currentDate = new Date();
			const currentDayOfMonth = currentDate.getDate();
			const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
			const currentYear = currentDate.getFullYear();

			const dateString = currentYear + '-' + (currentMonth + 1).toString().padStart(2, '0') + '-' + currentDayOfMonth.toString().padStart(2, '0');
			if (reqEndDate >= dateString) return true;
			else return false;
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetConversationUnreadCount({
				receivedByID: this.company.id,
				sentByID: this.set.request.id,
			});
			this.unreadMessageCount = unreadCount;
		},
	},
};
</script>
